import { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Application } from '../../atoms/application'
import { APP_STORE_APPS, GOOGLE_PLAY_APPS } from '../../data/appData'
import css from './MenuApp.sass'

class MenuApp extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      activeApp: '',
    }

    this.selectApp = (app = '') => {
      this.setState({ activeApp: app })
    }

    // eslint-disable-next-line max-len
    this.getClassName = (app) =>
      (this.state.activeApp === app && css.active) || (this.state.activeApp && css.inactive) || ''
  }

  render() {
    const { className } = this.props
    const { selectApp, getClassName } = this
    const { activeApp } = this.state

    return (
      <div className={cx(css.root, className)}>
        <div className={cx(css.stores, activeApp && css.active)}>
          <div className={cx(css.store, this.getClassName('appStore'))} onClick={() => selectApp('appStore')}>
            <div className={cx(css.nameIcon, css.nameIconApple)} />
          </div>
          <div className={cx(css.store, this.getClassName('googlePlay'))} onClick={() => selectApp('googlePlay')}>
            <div className={cx(css.nameIcon, css.nameIconGoogle)} />
          </div>
        </div>

        <div className={css.inner}>
          <div className={cx(css.app, this.getClassName('appStore'))}>
            <div onClick={() => selectApp('appStore')} className={cx(css.name, css.iconStore)}>
              <div className={cx(css.nameIcon, css.nameIconApple)} />
              <span className={css.nameText}>App Store</span>
            </div>
            <div className={css.about}>
              <div className={css.description}>
                Загрузите приложение <br />
                из Apple App Store
              </div>
              <div className={css.links}>
                <div className={css.linksInner}>
                  {/* eslint-disable-next-line max-len */}
                  {APP_STORE_APPS.filter(({ hidden }) => !hidden).map((item, index) => (
                    <Application {...item} key={item.id || index} />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className={cx(css.app, getClassName('googlePlay'))}>
            <div onClick={() => selectApp('googlePlay')} className={cx(css.name, css.iconGoogle)}>
              <div className={cx(css.nameIcon, css.nameIconGoogle)} />
              <span className={css.nameText}>Google Play</span>
            </div>
            <div className={css.about}>
              <div className={css.description}>
                Загрузите приложение <br />
                из Google Play Store
              </div>
              <div className={css.links}>
                <div className={css.linksInner}>
                  {/* eslint-disable-next-line max-len */}
                  {GOOGLE_PLAY_APPS.filter(({ hidden }) => !hidden).map((item, index) => (
                    <Application {...item} key={item.id || index} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(css.closeButton, activeApp && css.closeButtonActive)} onClick={() => selectApp()} />
      </div>
    )
  }
}

MenuApp.propTypes = {
  className: PropTypes.string,
}

export { MenuApp }
